/** Where a person can turn the interface's motion off (P5g); tests and the settings write it too. */
export const MOTION_KEY = 'os.motion';

type Media = (query: string) => { matches: boolean };

/** True when motion should stay still: the stored choice first, then the system's reduced-motion setting. */
export function motionOff(storage: Pick<Storage, 'getItem'> | null = globalThis.localStorage ?? null, media: Media | null = globalThis.matchMedia?.bind(globalThis) ?? null): boolean {
  try {
    if (storage?.getItem(MOTION_KEY) === 'off') return true;
  } catch {
    // storage blocked (private mode): fall back to the system setting
  }
  return !!media?.('(prefers-reduced-motion: reduce)').matches;
}

/** Marks `<html data-motion="off">` at start-up when motion is off; globals.css then stills every transition. */
export function applyMotion(root: HTMLElement = document.documentElement, storage?: Pick<Storage, 'getItem'> | null, media?: Media | null): void {
  if (motionOff(storage, media)) root.dataset.motion = 'off';
}
